import { create } from "zustand";
import axios from "axios";

const usePlanStore = create((set) => ({
  planData: null,
  /* GET /userPlan returns live counts alongside the plan document. They used
     to be dropped on the floor, so the UI could only show the limits from
     the plan ("Team seats: 10") and never the usage against them. */
  planUsage: null,
  planLoading: false,
  planError: null,
  fetchUserPlan: async () => {
    set({ planLoading: true, planError: null });
    try {
      const token = localStorage.getItem("userToken");
      if (!token) {
        throw new Error("No user token found.");
      }
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/auth/v1/userPlan`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      set({
        planData: response.data.plan,
        planUsage: {
          totalUsers: response.data.totalUsers,
          totalProducts: response.data.totalProducts,
        },
        planLoading: false,
      });
    } catch (error) {
      /* A non-admin with no subscription gets 403 "No active plan found"
         from GET /userPlan. That is a state, not a failure, so it must not
         become planError: the pages were showing a red "Failed to load
         subscription details" box to every user who simply had not
         subscribed yet. Leave planData null and let callers render their
         own empty state with a CTA. */
      if (error.response?.status === 403) {
        set({
          planData: null,
          planUsage: null,
          planError: null,
          planLoading: false,
        });
        return;
      }

      /* A rejected token is not a subscription failure. This API's auth
         middleware answers an invalid token with 500 "Invalid Token" rather
         than 401, so without this check a stale token surfaced as a red
         "Failed to load subscription details" banner on a page the user was
         no longer authenticated for. Let useUserStore clear the token; here
         we just avoid claiming the subscription is broken. */
      const status = error.response?.status;
      if (
        status === 401 ||
        error.response?.data?.message === "Invalid Token"
      ) {
        set({
          planData: null,
          planUsage: null,
          planError: null,
          planLoading: false,
        });
        return;
      }

      console.error("Error fetching user's subscription:", error);
      set({
        planError: "Failed to load subscription details.",
        planLoading: false,
      });
    }
  },
}));

export default usePlanStore;
